
import { useCallback } from "react"

export default ({ label, up, down, children, ...props }) => {
  const onUp = useCallback((e) => {
    up(e, props)
  })

  const onDown = useCallback((e) => {
    down(e, props)
  })

  return <div className="flex-1 text-center fcol">
           <div onClick={ onUp } className="pb-4">
             <div className="btn btn-primary btn-icon btn-lg"><i className="ph ph-plus" /></div>
           </div>
           <div className="flex-1">
             <div className="text-xs">{ label }</div>
             { children }
           </div>
           <div onClick={ onDown } className="pt-4">
             <div className="btn btn-primary btn-icon btn-lg"><i className="ph ph-minus" /></div>
           </div>
         </div>
}
